import React from 'react';
import { useTranslation } from 'react-i18next';

const CareersPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="px-6 py-8 sm:px-10 sm:py-12">
            <div className="mb-8 text-center">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">
                {t('careers.title')}
              </h1>
              <p className="text-gray-600 text-xl mb-6">
                {t('careers.subtitle')}
              </p>
            </div>
            <div className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('careers.openPositionsTitle')}
              </h2>
              <ul className="space-y-6">
                <li>
                  <h3 className="text-lg font-bold text-cyan-700 mb-1">
                    {t('careers.positions.engineer.title')}
                  </h3>
                  <p className="text-gray-700 mb-1">
                    {t('careers.positions.engineer.description')}
                  </p>
                  <span className="text-gray-500 text-sm">
                    {t('careers.positions.engineer.location')}
                  </span>
                </li>
                <li>
                  <h3 className="text-lg font-bold text-cyan-700 mb-1">
                    {t('careers.positions.marketing.title')}
                  </h3>
                  <p className="text-gray-700 mb-1">
                    {t('careers.positions.marketing.description')}
                  </p>
                  <span className="text-gray-500 text-sm">
                    {t('careers.positions.marketing.location')}
                  </span>
                </li>
                <li>
                  <h3 className="text-lg font-bold text-cyan-700 mb-1">
                    {t('careers.positions.legal.title')}
                  </h3>
                  <p className="text-gray-700 mb-1">
                    {t('careers.positions.legal.description')}
                  </p>
                  <span className="text-gray-500 text-sm">
                    {t('careers.positions.legal.location')}
                  </span>
                </li>
              </ul>
            </div>
            <div className="text-center mt-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('careers.applyTitle')}
              </h2>
              <p className="text-gray-700 mb-6">
                {t('careers.applyDescription')}
              </p>
              <a
                href="mailto:careers@tvia.ai"
                className="inline-block bg-cyan-600 text-white px-8 py-3 rounded-md font-semibold hover:bg-cyan-700 transition-colors"
              >
                {t('careers.applyButton')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareersPage;